import { Wrapper } from "./LeaderBoard.styled";
import React from "react";
import SampleImage from "../../../assets/images/testerimagesample.jpg";
import { data } from "./dummyData";
import LeaderBoardEntity from "./LeaderBoardEntity/LeaderBoardEntity";
import { Col, Row } from "components/common";
const LeaderBoardComponenet = () => {
  return (
    <Wrapper>
      <div className="leaderboard-container">
        <div>
          <div className="position-holders">
            <div className="position-holder-numbers">
              <div>
                <img
                  src={SampleImage}
                  alt=""
                  className="_2nd-position-holder"
                />
              </div>
              <div className="holder-two">2</div>
              <div className="ranker-name">
                <div>
                  <h4>Paul Constant</h4>
                </div>
                <div>
                  <h5>Ft. Myers</h5>
                </div>
                <div>
                  <h3 className="sales-color">4 Sales</h3>
                  <h6 style={{color:"#5ec9f4"}}>40Kw</h6>
                </div>
              </div>
            </div>
            <div className="position-holder-numbers">
              <div>
                <img
                  src={SampleImage}
                  alt=""
                  className="_1nd-position-holder"
                />
              </div>

              <div className="holder-one">1</div>
              <div className="ranker-name">
                <div>
                  <h4>Luke Knight</h4>
                </div>
                <div>
                  <h5>Melbourne</h5>
                </div>
                <div>
                  <h3 className="sales-gold">5 Sales</h3>
                </div>
                <div className="sale">
                  <p>50Kw</p>
                </div>
              </div>
            </div>
            <div className="position-holder-numbers">
              <div>
                <img
                  src={SampleImage}
                  alt=""
                  className="_2nd-position-holder"
                />
              </div>
              <div className="holder-two">3</div>
              <div className="ranker-name">
                <div>
                  <h4>Paul Constant</h4>
                </div>
                <div>
                  <h5>Ft. Myers</h5>
                </div>
                <div>
                  <h3 className="sales-color">4 Sales</h3>
                </div>
                <div>
                  <h6 style={{color:"#5ec9f4"}}>30Kw</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="border-line"></div>
        <div className="seller-tags">
          <Row className="headings">
            <Col className="rank-title" xs={5} sm={5} md={5} lg={6}>
              <h5>Rank</h5>
            </Col>
            <Col className="rank-title" xs={9} sm={9} md={9} lg={8}>
              <h5>Rep</h5>
            </Col>
            <Col className="rank-title" xs={5} sm={5} md={5} lg={5}>
              <h5>Sales</h5>
            </Col>
            <Col className="rank-title" xs={5} sm={5} md={5} lg={5}>
              <h5>KW</h5>
            </Col>
          </Row>
        </div>
      </div>

      {data.map((item) => {
        return <LeaderBoardEntity data={item} />;
      })}
    </Wrapper>
  );
};

export default LeaderBoardComponenet;
